const BlogSearch = {
  // Token liberado somente para o endpoint /api/collections/get/posts
  Token: 'f1f0373519737d8cb22d2f4a953665',
  baseURLApi: `${window.location.origin}/admin/conteudo`,
  baseList: document.querySelector('[data-posts-list]'),
  initialPosts: '',

  // ====================================================== //
  // ================ Faz o fetch dos posts =============== //
  // ====================================================== //
  api(search){
    const _this = this;

    fetch(`${_this.baseURLApi}/api/collections/get/posts`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Cockpit-Token': `${_this.Token}`
      },
      body: JSON.stringify({
        filter: {
          publish:true,
          // Pode usar $and
          $or: [
            // $options faz com que a filtragem não seja case sensitive
            {content: {$regex: `${search}`, $options: 'i'  }},
            {title: { $regex: `${search}`, $options: 'i'}},
            {description: { $regex: `${search}`, $options: 'i'}}
          ]
        },
        limit: 10,
        sort: {_created:-1},
        populate: 1,
      })
    })
    .then(res=>res.json())
    .then(res => {
      // Lista os posts
      _this.listPosts(res.entries);

      // Seta o spinner de loading como false e remove o spinner
      _this.setIsLoading(false);

      // Scroll para o topo da página
      _this.scrollToTop();
      console.log(res);
    })
    .catch(err => {
      console.log(err);
      // Seta o spinner de loading como false e remove o spinner
       _this.setIsLoading(false);
    })
  },

  // ================================================================== //
  //  Responsável por guardar os posts iniciais ao carregar a página    //
  // ================================================================== //
  maintainActualPosts(){
    const _this = this
    const Posts = _this.baseList.innerHTML

    // Guarda os posts iniciais
    _this.initialPosts = Posts
  },

  // ====================================================== //
  //  Função para atrasar a busca, executa ao término do timer  //
  // ====================================================== //
  debounce(cb, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    }
  },

  // ====================================================== //
  //  Faz com que o scroll volte para o topo da página após a busca  //
  // ====================================================== //
  scrollToTop(){
    // A ancora do scroll é um span com o atributo data-anchor
    document.querySelector('[data-anchor]').scrollIntoView(
      {
        behavior: "smooth",
        block: "start"
      }
    );
  },

  // ====================================================== //
  // == Ajusta a data dos posts para o formato brasileiro = //
  // ====================================================== //
  dateAdjust(date){
    const _this = this
    const dateAdjust = date.split('-').reverse().join('.')
    return dateAdjust
  },

  // ====================================================== //
  // ========= Seta o spinner de loading no input ========= //
  // ====================================================== //
  setIsLoading(boolean){
    let spinner = document.querySelector('[data-search-spinner]')
    boolean == true ? (spinner.style.display = 'inline-block') : (spinner.style.display = 'none')
  },

  // ====================================================== //
  // ============= Monta o template dos posts ============= //
  // ====================================================== //
  templatePost(post){
    const _this = this;

    return `
      <article class="post">
         <a href="${window.location.origin}/m/sarahtalks/${ post._id }/${ post.permalink }" class="link">
          <div class="image">
            <span class="overlay">
              <div class="text">LER MAIS</div>
            </span>
            <img class="lazy" data-src="${ post.thumb.path}" alt="Foto do post ${ post.title }" />
          </div>
          <p class="date">${ _this.dateAdjust(post.date) }</p>
          <h2 class="title">${ post.title }</h2>
          <p class="excerpt">
            ${ post.description }
          </p>
        </a>
      </article>
    `;
  },

  // ====================================================== //
  // =========== Lista os posts seção setada ============== //
  // ====================================================== //
  listPosts( Posts ){
    const _this = this

    // Limpa a lista
    _this.baseList.innerHTML = '';

    // document.createDocumentFragment agrupa os elementos para serem inseridos de uma única vez
    // Evita que o DOM seja atualizado a cada novo elemento
    const fragmentDOM = document.createDocumentFragment()
    Posts.forEach(post => {
      const template = _this.templatePost(post)
      fragmentDOM.appendChild(document.createRange().createContextualFragment(template))
    });

    // Insere o fragmento no DOM
    _this.baseList.appendChild(fragmentDOM);

    // Atualiza o lazyload
    window.lazyLoadInstance.update();

  },

  // ====================================================== //
  //  Responsável por pegar o valor do input e ajustar a regex da busca  //
  // ====================================================== //
  searchRegex(value) {
    // Remove os espaços em branco do início e do fim e adiciona o pipe (|)
    // Monta a regex da seguinte forma, ex: (palavra1|palavra2|palavra3)

    let regex = `(${value.replace(/( )+/g, '|')})`;

    // Trata a regex da busca
    if ( regex.charAt( regex.length - 2 ) == '|') {
     // remove o ultimo caracter
     regex =  regex.replace('|', '')
    }
    // console.log('REGEX', regex);
    this.api(regex);
  },

  // ====================================================== //
  // =========== FAZ A BUSCA COM O DEBOUNCE ============== //
  // ====================================================== //
  search() {
    const _this = this
    const search = document.getElementById('searchBlog');

    // Listener com o debounce com delay de 1000ms para evitar o carregamento excessivo de requisições
    search.addEventListener('input', this.debounce((e)=>{
      if ( e.target.value !== '' ) {

        // Seta o loading do input para o usuário saber que está sendo feito uma busca
        _this.setIsLoading(true);

        // Mostra os posts de acordo com o que o usuário digitou
        _this.searchRegex(e.target.value);
      } else {
        // Se o campo estiver vazio, mostra os posts iniciais
        _this.baseList.innerHTML = _this.initialPosts
        window.lazyLoadInstance.update();
      }
    }, 1000));
  },

  init() {
    // Pega os posts iniciais
    this.maintainActualPosts();
    this.search();
  }
}

BlogSearch.init();
